import { CognitoUserPool, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';

const cognitoConfig = {
  region: process.env.REACT_APP_REGION || 'us-west-2',
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-west-2_8pRTDgXdF',
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '354arlmd5u14k3td9qn9pfg54b',
  domain: process.env.REACT_APP_COGNITO_DOMAIN
    ? `https://${process.env.REACT_APP_COGNITO_DOMAIN}`
    : 'https://auth.decodedmusic.com'
};

const userPool = new CognitoUserPool({
  UserPoolId: cognitoConfig.userPoolId,
  ClientId: cognitoConfig.clientId
});

// Simple mock authentication service for demo purposes
class CognitoAuthService {
    constructor() {
        this.currentUser = null;
        this.jwtToken = null;
    }

    async signIn(email, password) {
        const authDetails = new AuthenticationDetails({
            Username: email,
            Password: password
        });

        const user = new CognitoUser({
            Username: email,
            Pool: userPool
        });

        return new Promise((resolve, reject) => {
            user.authenticateUser(authDetails, {
                onSuccess: (result) => {
                    const token = result.getIdToken().getJwtToken();
                    localStorage.setItem('cognito_token', token);
                    resolve({ success: true, user: email, token });
                },
                onFailure: (err) => {
                    reject({ success: false, error: err.message });
                }
            });
        });
    }

  async getCurrentUser() {
        const currentUser = userPool.getCurrentUser();

        if (!currentUser) {
            return { success: false, user: null };
        }

        return new Promise((resolve) => {
            currentUser.getSession((err, session) => {
                if (err || !session?.isValid()) {
                    console.warn('Session expired or invalid. Logging out...');
                    this.signOut();
                    resolve({ success: false, error: err ? err.message : 'Session invalid' });
                } else {
                    resolve({
                        success: true,
                        user: currentUser.getUsername(),
                        token: session.getIdToken().getJwtToken()
                    });
                }
            });
        });
    }

    hasCurrentUser() {
        return !!userPool.getCurrentUser();
    }

    async signOut() {
        const currentUser = userPool.getCurrentUser();
        if (currentUser) {
            currentUser.signOut();
            localStorage.removeItem('cognito_token');
        }
    }
}

export default new CognitoAuthService();